export default {
  en: {
    userList: 'User List',
    newUser: 'New User',
    username: 'Username',
    acceptOnlyCharacter: 'accept only characters (a-z 0-9 _ -)',
    password: 'Password',
    randomPassword: 'Random password and sent to email.',
    manualPassword: 'Manual',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    status: 'Status',
    create: 'Create',
    cancel: 'Cancel',
    createUserSuccessTitle: 'Success',
    createUserSuccessMessage: 'Create User Success.'
  },
  th: {
    userList: 'ผู้ใช้',
    newUser: 'สร้างผู้ใช้',
    username: 'ชื่อผู้ใช้',
    acceptOnlyCharacter: 'อนุญาตให้ใช้ตัวอักษร (a-z 0-9 _ -) เท่านั้น',
    password: 'รหัสผ่าน',
    randomPassword: 'สุ่มรหัสผ่านแล้วส่งไปยังอีเมล์',
    manualPassword: 'กำหนดเอง',
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    email: 'อีเมล',
    status: 'สถานะ',
    create: 'สร้างผู้ใช้',
    cancel: 'ยกเลิก',
    createUserSuccessTitle: 'สำเร็จ',
    createUserSuccessMessage: 'สร้างผู้ใช้สำเร็จ'
  }
}
